var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriggerImage1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#E0E6F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6895_19623",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6895_19623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 28V23.9L23.35 16.6C23.55 16.4 23.7708 16.25 24.0125 16.15C24.2542 16.05 24.5083 16 24.775 16C25.0417 16 25.2958 16.05 25.5375 16.15C25.7792 16.25 26 16.4 26.2 16.6L27.425 17.85C27.6083 18.05 27.75 18.2708 27.85 18.5125C27.95 18.7542 28 19 28 19.25C28 19.5 27.9458 19.7458 27.8375 19.9875C27.7292 20.2292 27.5833 20.45 27.4 20.65L20.1 28H16ZM18 26H19.25L23.3 21.95L22.05 20.7L18 24.75V26ZM16.75 15.25L15.35 13.825L17.175 12H13.825C13.675 12.4333 13.4417 12.8083 13.125 13.125C12.8083 13.4417 12.4333 13.675 12 13.825V22.175C12.5833 22.3917 13.0625 22.7542 13.4375 23.2625C13.8125 23.7708 14 24.35 14 25C14 25.8333 13.7083 26.5417 13.125 27.125C12.5417 27.7083 11.8333 28 11 28C10.1667 28 9.45833 27.7083 8.875 27.125C8.29167 26.5417 8 25.8333 8 25C8 24.35 8.1875 23.775 8.5625 23.275C8.9375 22.775 9.41667 22.4167 10 22.2V13.825C9.41667 13.6083 8.9375 13.2458 8.5625 12.7375C8.1875 12.2292 8 11.65 8 11C8 10.1667 8.29167 9.45833 8.875 8.875C9.45833 8.29167 10.1667 8 11 8C11.65 8 12.2292 8.1875 12.7375 8.5625C13.2458 8.9375 13.6083 9.41667 13.825 10H17.175L15.35 8.175L16.75 6.75L21 11L16.75 15.25ZM25 8C25.8333 8 26.5417 8.29167 27.125 8.875C27.7083 9.45833 28 10.1667 28 11C28 11.8333 27.7083 12.5417 27.125 13.125C26.5417 13.7083 25.8333 14 25 14C24.1667 14 23.4583 13.7083 22.875 13.125C22.2917 12.5417 22 11.8333 22 11C22 10.1667 22.2917 9.45833 22.875 8.875C23.4583 8.29167 24.1667 8 25 8ZM11 26C11.2833 26 11.5208 25.9042 11.7125 25.7125C11.9042 25.5208 12 25.2833 12 25C12 24.7167 11.9042 24.4792 11.7125 24.2875C11.5208 24.0958 11.2833 24 11 24C10.7167 24 10.4792 24.0958 10.2875 24.2875C10.0958 24.4792 10 24.7167 10 25C10 25.2833 10.0958 25.5208 10.2875 25.7125C10.4792 25.9042 10.7167 26 11 26ZM11 12C11.2833 12 11.5208 11.9042 11.7125 11.7125C11.9042 11.5208 12 11.2833 12 11C12 10.7167 11.9042 10.4792 11.7125 10.2875C11.5208 10.0958 11.2833 10 11 10C10.7167 10 10.4792 10.0958 10.2875 10.2875C10.0958 10.4792 10 10.7167 10 11C10 11.2833 10.0958 11.5208 10.2875 11.7125C10.4792 11.9042 10.7167 12 11 12ZM25 12C25.2833 12 25.5208 11.9042 25.7125 11.7125C25.9042 11.5208 26 11.2833 26 11C26 10.7167 25.9042 10.4792 25.7125 10.2875C25.5208 10.0958 25.2833 10 25 10C24.7167 10 24.4792 10.0958 24.2875 10.2875C24.0958 10.4792 24 10.7167 24 11C24 11.2833 24.0958 11.5208 24.2875 11.7125C24.4792 11.9042 24.7167 12 25 12Z",
    fill: "#EF7707"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggerImage1);
export default __webpack_public_path__ + "static/media/triggerImage1.4613dfe3aba092ea7359d048b71d1a7d.svg";
export { ForwardRef as ReactComponent };